import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../images/spinner.svg';
import './style.css';

export default class Processing extends React.Component {
  static propTypes = {
    message: PropTypes.string
  };

  static defaultProps = {
    message: ''
  };

  render() {
    let message = this.props.message && this.props.message.length > 0 ? <h1 className="processing-message">{this.props.message}</h1> : null;

    return (
      <div className="processing-component">
        <div className="processing-spinner"><img src={Spinner} role="presentation" /></div>
        {message}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Processing/index.js
 **/